/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CompanyGuardianAngels = {
    type: 'array',
    contains: {
        type: 'CompanyGuardianAngel',
    },
};